import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_certificate_update",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "certificate_update",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_certificate_update_button",
  "data-kt-drawer-close": "#kt_drawer_certificate_update_close",
  "data-kt-drawer-width": "72.5vw"
}
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Training Certificate Template Configuration ")
  ])
], -1)
const _hoisted_4 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Left Signatory", -1)
const _hoisted_11 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Right Signatory", -1)
const _hoisted_13 = {
  key: 2,
  class: "col-sm-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Upload Left Signature", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 3,
  class: "col-sm-4 mt-6"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Upload Right Signature", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-md-2 mt-14" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.formData.type == 'Training Institute')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.formData.left_signatory,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.left_signatory) = $event)),
                        name: "left_signatory",
                        class: "form-control form-control-sm",
                        style: {"height":"40px","width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.formData.type == 'Training Partner')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.formData.right_signatory,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.right_signatory) = $event)),
                        name: "right_signatory",
                        class: "form-control form-control-sm",
                        style: {"height":"40px","width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.formData.type == 'Training Institute')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("input", {
                        type: "file",
                        ref: "leftFileInput",
                        class: "form-control",
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLeftChange && _ctx.onLeftChange(...args))),
                        style: {"width":"100%"}
                      }, null, 544)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.formData.type == 'Training Partner')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createElementVNode("input", {
                        type: "file",
                        ref: "rightFileInput",
                        class: "form-control",
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onRightChange && _ctx.onRightChange(...args))),
                        style: {"width":"100%"}
                      }, null, 544)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args))),
                    type: "button",
                    class: "btn btn-success p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Update "),
                    _hoisted_20
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}